import {Component, Input, OnInit} from '@angular/core';
import {BookmarkService} from 'lps-navigation';

@Component({
  selector: 'lps-bookmark',
  templateUrl: './bookmark.component.html',
  styleUrls: ['./bookmark.component.scss']
})
export class BookmarkComponent implements OnInit {

  constructor(private readonly bookmarkService: BookmarkService) {}

  @Input()
  public productId?: string;
  @Input()
  public displayDescription: boolean;
  @Input()
  public displayLinear: boolean;
  public isBookmarked: boolean;

  ngOnInit(): void {
    this.updateIsBookmarked();
  }

  updateIsBookmarked(): void {
    this.isBookmarked = this.bookmarkService.isBookmarked(this.productId);
  }

  toggleBookmark(): void {
    this.bookmarkService.toggleBookmark(this.productId);
    this.updateIsBookmarked();
  }

  getDescription(): string {
    return this.isBookmarked
      ? 'Desfazer'
      : 'Favoritar';
  }
}
